<div class="network-status-indicator">
	<div id="toolbar-network-status-online" *ngIf="IsOnline" class="material-symbols-outlined online">bigtop_updates</div>
	<div id="toolbar-network-status-offline" *ngIf="!IsOnline" class="material-symbols-outlined offline">signal_disconnected</div>
</div>